import { useState } from 'react';

export type UseRefreshType = () => [number, () => void];

const useModal = <T = any>(defaultVisible = false, defaultData = null as any) => {

  const [visible, setVisible] = useState(defaultVisible);
  const [data, putData] = useState<T>(defaultData as T);

  return {
    open: visible,
    data,
    show: (value: any = undefined) => {
      if (value !== undefined) {
        putData(value as T);
      }
      setVisible(true);
    },
    hide: () => setVisible(false),
    toggle: () => setVisible(!visible)
  };
};

export interface ModalHook extends ReturnType<typeof useModal> { }
export default useModal;
